import { getDefaultStore } from 'jotai';

import { invalidatePiiRelatedQueries } from 'components/PiiSession/utils/invalidatePiiRelatedQueries';
import { userAtom } from 'store/userAtom';
import { piiModalOpenAtom } from 'store/piiModalOpenAtom';
import { piiTokenAtom } from 'store/piiEnabledAtom';
import type { User } from 'types/User';
import { queryClient } from 'queryClient';

/**
 * Clears Lead Revival / PII session when auth sets `userAtom` to null/undefined.
 * Uses Jotai store subscription so it runs even when the App route unmounts before React effects see logout.
 */
export function subscribePiiClearOnLogout(): void {
  const store = getDefaultStore();
  let prevUser: User | null | undefined = store.get(userAtom) as User | null | undefined;

  store.sub(userAtom, () => {
    const u = store.get(userAtom) as User | null | undefined;
    const wasDefined = prevUser !== undefined && prevUser !== null;
    const isNil = u === undefined || u === null;
    if (wasDefined && isNil) {
      store.set(piiTokenAtom, null);
      store.set(piiModalOpenAtom, false);
      invalidatePiiRelatedQueries(queryClient);
    }
    prevUser = u;
  });
}
